import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/motorway-logo-shorthand.svg';
import { Icon } from '../Icon/Icon';
export const MotorwayLogoShorthandIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
